<p-toolbar [style]="{'margin-bottom': '5px'}">
    <div class="p-toolbar-group-left">
       Usuário: <b>{{currentUser.nome}}</b>           
    </div>
    <div style="float: right">
        Versão: <b>{{version}}</b>
       </div>
</p-toolbar>

<p-menubar [model]="items" [style]="{'background-color':'white'}">
    <ng-template pTemplate="start">
        <a> <img src="assets/logo.jpeg" height="50" width="50" class="p-mr-2"></a>       
    </ng-template>
    <ng-template pTemplate="end">
        <button pButton [style]="{'background-color':'red'}" icon="pi pi-power-off" (click)="logout()"></button>
    </ng-template>
</p-menubar>
<h1 style="letter-spacing: 1px;margin-top: 5px;margin-bottom: 5px;"></h1>
<router-outlet></router-outlet>